import { Component } from '@angular/core';
import * as moment from 'moment';
import { CovanceFilterBaseTypeComponent } from './covance-filter-base-type.component';
import { CovanceFilterDateType } from './covance-filter-date-type';

@Component({
    selector: 'covance-filter-date-type',
    template: require('./covance-filter-date-type.component.html')
})
export class CovanceFilterDateTypeComponent extends CovanceFilterBaseTypeComponent<CovanceFilterDateType> {
    constructor(filterType: CovanceFilterDateType) {
        super(filterType);
    }

    public onDateChange($event: moment.Moment) {
        this.fieldVal.value = this.filterType.formatDateTime($event);
        this.filterType.setQueryParamValue(this.fieldVal);
        this.filterType.onFieldChange(this.fieldVal);
    }
}